import { ModuleType, TierType } from 'global-services/constants/OhsObject';

export interface OhsLtiTargetTier {
  _id: string;
  type: TierType;
}
export interface OhsIncidentLtiFilterPayload {
  viewPreset: OhsIncidentLtiViewPresets;
  targetTier?: OhsLtiTargetTier;
  page: number;
  sort: {
    order: number;
    key: string;
  };
  count: boolean;
}

export interface OhsIncidentLtiRecord {
  id: string;
  year: string;
  role: string;
  jan: number | null;
  feb: number | null;
  mar: number | null;
  apr: number | null;
  may: number | null;
  jun: number | null;
  jul: number | null;
  aug: number | null;
  sep: number | null;
  oct: number | null;
  nov: number | null;
  dec: number | null;
}

export interface OhsIncidentLtiRecordResponse {
  _id: string;
  type: ModuleType;
  tier: {
    type: TierType;
    _id: string;
  };
  role: string;
  year: number;
  hours: {
    jan: number;
    feb: number;
    mar: number;
    apr: number;
    may: number;
    jun: number;
    jul: number;
    aug: number;
    sep: number;
    oct: number;
    nov: number;
    dec: number;
  };
  createdBy: {
    type: ModuleType.User;
    _id: string;
    name: string;
    email: string;
  };
  tzDateCreated: string;
  dateCreated: string;
}

export const incidentsLtiRecord: OhsIncidentLtiRecord = {
  id: '',
  year: '',
  role: '',
  jan: null,
  feb: null,
  mar: null,
  apr: null,
  may: null,
  jun: null,
  jul: null,
  aug: null,
  sep: null,
  oct: null,
  nov: null,
  dec: null,
};

export enum OhsIncidentLtiViewPresets {
  view1 = 'view_1',
  view2 = 'view_2',
  view3 = 'view_3',
}

export const getIncidentLtiViewPresets = (
  payload: OhsIncidentLtiFilterPayload,
  tierNum: number
) => {
  switch (tierNum) {
    case 3:
      return OhsIncidentLtiViewPresets.view1;
    case 4:
    case 5:
      return OhsIncidentLtiViewPresets.view2;
    default:
      return OhsIncidentLtiViewPresets.view1;
  }
};

export interface OhsltiWorkplace {
  name: string;
  id: string;
  tier: TierType;
}

export type TransformedLtiHoursData = {
  [year: string]: {
    [role: string]: {
      [month: string]: number;
    };
  };
};

export const litMonths = [
  'jan',
  'feb',
  'mar',
  'apr',
  'may',
  'jun',
  'jul',
  'aug',
  'sep',
  'oct',
  'nov',
  'dec',
];
